export const formContent = {
    heading: 'Your business service area',
    coverageType: {
        id: 'coverageType',
        label: 'Select one option from below',
        options: [
            { value: 'nationalCoverage', label: 'State/National coverage' },
            { value: 'locationCoverage', label: 'Location service area' }
        ],
        validation: {
            required: "Please select coverage type"
        }
    },
    nationalCoverage: {
        id: 'nationalCoverage',
        options: [],
        validation: {
            required: "Please select states"
        }
    },
    locationCoverage: {
        id: 'locationCoverage',
        label: 'Choose coverage area from location'
    },
    category: {
        id: 'category',
        label: 'Select category',
        options: [],
        validation: {
            required: "Please select categories",
            validate: arr => arr.length<=6 || "Max 6 categories allowed"
        }
    },
    keyWord: {
        id: 'keyWord',
        label: 'Keywords',
        validation: {
            required: "Please select keywords"
        }
    },
    saveButton: {
        id: 'saveButton',
        label: 'Save',
        type: 'submit'
    }
}
